import NsContent from 'components/common/ns-content/NsContent';
import { useDispatch } from 'react-redux';

import { NsBackCta } from 'components/common/ns-back-cta/NsBackCta';
import { NsPanel } from 'components/common/ns-panel/NsPanel';
import { NsPrimaryCta } from 'components/common/ns-primary-cta/NsPrimaryCta';
import { NsTitle } from 'components/common/ns-title/NsTitle';
import { NsForm } from 'components/common/ns-form/NsForm';
import { AddressItem } from 'components/common/address-item/AddressItem';
import { usePersonalInformationSummary } from 'components/direct-sales/personal-information-summary/hooks/usePersonalInformationSummary';
import { EnergyEstimation } from 'components/direct-sales/personal-information-summary/components/EnergyEstimation';
import { useGetSapQuote } from 'hooks/useGetSapQuote';
import { useIsLoginEnabledJourney } from 'hooks/useIsLoginEnabledJourney';
import { PersonalInformationPlayback } from './components/PersonalInformationPlayback';
import { useNavigation } from 'hooks/useNavigation';
import { resetStateToInitial } from 'state/reset-state/reset-state-actions';

export const testId = 'personalInformationSummaryTestId';

export const PersonalInformationSummary = () => {
  const { eventTypes, next } = useNavigation();
  const {
    address,
    fuelTypeText,
    fuelType,
    consumption,
    isLoading
  } = usePersonalInformationSummary();
  const dispatch = useDispatch();
  const getSapQuote = useGetSapQuote();

  const isAgentSalesJourney = useIsLoginEnabledJourney();

  const ctaTitle = isAgentSalesJourney ? 'Go to home page' : 'Continue';
  const pageTitle = isAgentSalesJourney
    ? 'Sorry, we are not able to quote this customer in NEP'
    : "Here is what you've told us so far";
  const pageSubtitle = isAgentSalesJourney
    ? `Please use ‘Workbench’ to provide a quote for this customer.`
    : `Please check the information below is correct, so we can 
                          provide you with the best tariff options.`;

  const changeAddress = () => {
    next({ eventType: eventTypes.CHANGE_ADDRESS, wasVisited: true });
  };

  const changeConsumption = () => {
    next({ eventType: eventTypes.CHANGE_CONSUMPTION, wasVisited: true });
  };

  const handleGoNext = async () => {
    if (isAgentSalesJourney) {
      next({ eventType: eventTypes.NEXT, wasVisited: true });
      dispatch(resetStateToInitial());
    }

    try {
      await getSapQuote();
    } catch (error) {
      error && console.error(error);
    }
  };

  const items = [
    {
      title: 'Your address',
      content: <AddressItem address={address} hasTitle={false} />,
      handler: changeAddress,
      canEdit: true
    },
    {
      title: 'You need',
      content: fuelTypeText,
      canEdit: false
    },
    {
      title: 'Energy estimation',
      content: (
        <EnergyEstimation fuelType={fuelType} consumption={consumption} />
      ),
      handler: changeConsumption,
      canEdit: true
    }
  ];

  return (
    <NsPanel testId={testId}>
      <NsBackCta />
      <NsContent>
        <NsTitle title={pageTitle} />
        <p>{pageSubtitle}</p>
      </NsContent>
      <PersonalInformationPlayback items={items} />
      <NsForm onSubmit={handleGoNext}>
        <NsPrimaryCta isLoading={isLoading}>{ctaTitle}</NsPrimaryCta>
      </NsForm>
    </NsPanel>
  );
};

export default PersonalInformationSummary;
